import { useMutation, useQuery, useQueryClient } from "react-query";
import { AxiosError } from "axios";
import { CONFIG } from "../config";
import { createUser, getAllUsers, updateUser } from "../api/users";
import { CreateUserPayload, UpdateUserPayload, User, UsersFilterParams } from "../@types/users";

export const useUsers = (filters?: UsersFilterParams) => {
  return useQuery(
    ['users', filters],
    () => {
      return getAllUsers(filters);
    },
    {
      retry: false,
      refetchInterval: CONFIG.AUTO_REFETCH_INTERVAL,
    },
  );
};

export const useCreateUser = () => {
  const queryClient = useQueryClient();

  return useMutation<User, AxiosError<{ errorMessage?: string }>, CreateUserPayload>(
    ['create-user'],
    (payload) => createUser(payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['users']);
      },
    },
  );
};

export const useUpdateUser = () => {
  const queryClient = useQueryClient();

  return useMutation<User, AxiosError<{ errorMessage?: string }>, UpdateUserPayload>(
    ['update-user'],
    (payload) => updateUser(payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['users']);
      },
    },
  );
};
